
export default (response) => (response && response.data && response.data.meta) || {};
